import { render, staticRenderFns } from "./BreadCrumbArrowIcon.vue?vue&type=template&id=2d032581&scoped=true"
import script from "./BreadCrumbArrowIcon.vue?vue&type=script&lang=js"
export * from "./BreadCrumbArrowIcon.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumbArrowIcon.vue?vue&type=style&index=0&id=2d032581&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d032581",
  null
  
)

export default component.exports